import Formserachauthorization from '@/views/private/finance/expenses/travelrefund/formserachauthorization/formserachauthorization.vue'
import { loading, toast } from '@/shared/utils/UIHelper'
import ActionsForm from '@/shared/mixins/actionsForm'
import TetoRelatorioLotes from '@/shared/mixins/tetoRelatorioLotes'
import Tools from '@/components/tools/Tools.js'
import detailsModal from './components/detailsModal.vue'
import filterForm from './components/filterForm.vue'
import MiscellaneousExpensesRepository from '@/shared/http/repositories/business/miscellaneousexpenses'
import { parseInt } from 'lodash'
import reportPdf from '@/views/private/miscellaneousreimbursement/components/CollaboratorTableTravelExpenseEmployeSeveral/components/reportPdf.vue'

const name = 'CollaboratorTableTravelExpenseEmployeSeveral'

export default {
  name,
  mixins: [ActionsForm, TetoRelatorioLotes],
  components: { detailsModal, Formserachauthorization, filterForm, reportPdf
  },

  props: {
  },

  mounted () {
  },

  updated () { },

  data () {
    return {
      details: [],
      collabId: '',
      partId: '',
      partStartDate: '',
      partEndDate: '',
      partNumber: 0,
      totalPartValue: 0,
      detailsRepost: [],
      // loteIDs marcados. Array separado em vez de `detail.selecionado`: `details` vem da API e
      // propriedade nova em objeto ja criado nao e reativa no Vue 2 sem $set.
      selecionados: [],
      // "selecionar todos" NAO e "marcar as linhas visiveis": a grid do Diversos tambem vem sem
      // paginador (`:showPaging="false"`) e o colaborador medido no aceite tem 39 lotes com 190
      // comprovantes. Neste modo o body vai com `LoteIds: []`, que o backend le como TODOS.
      todosOsLotes: false
    }
  },

  methods: {
    onLoad () {
      let param = new URLSearchParams(window.location.search)
      this.collabId = param.get('funcionario')
      // depois do collabId: a chave dos baixados inclui o funcionario
      this.carregarBaixados()
      this.getDetailsbyIds(this.collabId)
    },
    async getDetailsbyIds (collabId) {
      loading.push()
      await MiscellaneousExpensesRepository.GetColaboratorTableTravelExpenseDetailsByFuncionarioId(collabId, this.CompanySelected, this.$refs.detailsTab.pagingLimit, this.$refs.detailsTab.pagingIndex)
        .then((Response) => {
          this.$refs.detailsTab.LoadAllByData(Response)
          this.details = Response.data.data
          // sem filtro: `details` e o conjunto inteiro do colaborador
          this.filtroDeLoteAtivo = false
          this.registrarAnexosDeDetalhes()
        })
        .catch(() => {})
        .finally(() => { loading.pop() })
    },
    formatMoney (value) {
      return Tools.formatMoney(value)
    },
    showModal (partId) {
      this.partId = partId
      this.$refs['detailsModalRef'].show()
    },

    async filterTableByPartNumber (partNumber) {
      let LoteNumerp = parseInt(partNumber)
      loading.push()
      await MiscellaneousExpensesRepository.GetColaboratorTableTravelExpenseDetailsByFuncionarioId(this.collabId, this.CompanySelected, this.$refs.detailsTab.pagingLimit, this.$refs.detailsTab.pagingIndex, { Lote: LoteNumerp, Valor: 0 })
        .then((Response) => {
          this.$refs.detailsTab.LoadAllByData(Response)
          this.details = Response.data.data
          // ZC-46: com filtro ligado `details` e um RECORTE. Quem le isso e o teto: o modo
          // "todos os lotes" manda LoteIds: [] (= TODOS no backend) e nao pode ser liberado
          // medindo uma linha filtrada. E `anexosPorLote` acumula, entao a soma da selecao
          // anterior nao se perde ao trocar `details`.
          this.filtroDeLoteAtivo = true
          this.registrarAnexosDeDetalhes()
        })
        .catch(() => {})
        .finally(() => { loading.pop() })
    },
    // selecao de lotes (ZC-42 passo 3) -----------------------------------------------------
    alternarLote (loteID) {
      // mexer numa linha sai do modo "todos": a partir daqui vale a lista explicita
      this.todosOsLotes = false
      const i = this.selecionados.indexOf(loteID)
      if (i >= 0) { this.selecionados.splice(i, 1); return }
      // ZC-46: o teto tambem e checado AQUI, e nao so no `:disabled` do checkbox. O
      // `b-form-checkbox` desabilitado nao dispara `change`, mas a regra nao pode morar apenas
      // na aparencia -- sair do modo "todos" ja mexeu no estado antes desta linha.
      const detail = (this.details || []).find(d => d.loteID === loteID)
      if (!this.podeMarcarLote(detail)) return
      this.selecionados.push(loteID)
    },

    // O Tables.vue emite 'check' com o INPUT do cabecalho (Tables.vue:69), nao com um boolean.
    marcarTodos (input) {
      this.todosOsLotes = !!(input && input.checked)
      this.selecionados = []
    },

    // Um PDF com os comprovantes dos lotes marcados. Acima do teto do servidor a resposta e 413 e
    // a mensagem dele diz quanto passou -- dai o catch LER o corpo: com responseType 'blob' o erro
    // chega como Blob e precisa de .text().
    //
    // NAO confundir com o `gerarPdf` logo abaixo, que e outra coisa: aquele monta a TABELA por
    // html2pdf no browser (reportPdf.vue) e nao tem notinha nenhuma.
    async gerarRelatorioSelecionados () {
      if (!this.todosOsLotes && !this.selecionados.length) return
      // ZC-46: teto de anexo/lote. A trava fica aqui tambem porque o `:disabled` do botao e
      // aparencia; quem garante e o guarda no metodo.
      if (this.motivoTetoRelatorio) { toast.error(this.motivoTetoRelatorio); return }

      loading.push()
      try {
        const Response = await MiscellaneousExpensesRepository.GerarPDFComprovantesFuncionario({
          FuncionarioId: this.collabId,
          EmpresaId: this.CompanySelected,
          LoteIds: this.todosOsLotes ? [] : this.selecionados
        })

        const fileURL = window.URL.createObjectURL(new Blob([Response.data], {type: 'application/pdf'}))
        const fileLink = document.createElement('a')
        fileLink.href = fileURL
        const sufixo = this.todosOsLotes ? 'todos-os-lotes' : `${this.selecionados.length}-lotes`
        fileLink.setAttribute('download', `comprovantes-diversos-colaborador-${sufixo}.pdf`)
        document.body.appendChild(fileLink)
        fileLink.click()
        fileLink.remove()
        window.URL.revokeObjectURL(fileURL)
        // marca DEPOIS do download dar certo: marcar antes mentiria em cima de um 413
        this.registrarBaixados(this.todosOsLotes ? [] : this.selecionados)
      } catch (Error) {
        let msg = 'Nao foi possivel gerar o relatorio.'
        const corpo = Error && Error.response && Error.response.data
        if (corpo && typeof corpo.text === 'function') {
          try {
            const texto = await corpo.text()
            if (texto) msg = texto.replace(/^"|"$/g, '')
          } catch (e) { /* fica a mensagem padrao */ }
        }
        toast.error(msg)
      } finally {
        loading.pop()
      }
    },

    async gerarPdf () {
      await MiscellaneousExpensesRepository.GetReportColaboratorTableTravelExpenseDetailsByFuncionarioId(this.collabId, this.CompanySelected)
        .then((Response) => {
          this.detailsRepost = Response.data.data
          this.$refs.reportPdf.detailsRepost = Response.data.data
          this.$refs.reportPdf.generatePDF()
        })
        .catch(() => {})
        .finally(() => { loading.pop() })
    }
  },

  computed: { }
}



// WEBPACK FOOTER //
// ./src/views/private/miscellaneousreimbursement/components/CollaboratorTableTravelExpenseEmployeSeveral/CollaboratorTableTravelExpenseEmployeSeveral.js